module.exports = __webpack_public_path__ + "img/hilton_logo.fb2cfa87.png";